import { useState } from 'react';
import { useSiteContent } from '@/context/SiteContentContext';

const strengths = [
  { icon: 'ri-team-line', title: 'Expert Team', desc: 'Highly trained professionals with multi-disciplinary backgrounds in ICT, GeoInformatics, and Research.', number: '01' },
  { icon: 'ri-global-line', title: 'Regional Reach', desc: 'Active across East Africa with projects in Kenya, Uganda, Tanzania, Ethiopia, and beyond.', number: '02' },
  { icon: 'ri-award-line', title: 'Proven Track Record', desc: 'Trusted by leading international organizations including WFP, IFAD, USAID-funded programs, and NSSF Uganda.', number: '03' },
  { icon: 'ri-lightbulb-line', title: 'Innovation-Driven', desc: 'At the forefront of Geoinformation, Research and IT with the latest tools and methodologies.', number: '04' },
];

export default function About() {
  const [activeCard, setActiveCard] = useState<number | null>(null);
  const { content } = useSiteContent();
  const a = content.about;

  return (
    <section id="about" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <span className="text-teal-600 text-sm font-semibold tracking-widest uppercase">Who We Are</span>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mt-3 mb-6 leading-tight">
              {a.heading1}<br /><span className="text-teal-600">{a.heading2}</span>
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed mb-6">{a.para1}</p>
            <p className="text-gray-600 leading-relaxed mb-8">{a.para2}</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
              <div className="bg-white rounded-xl p-5 border border-gray-100">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-teal-50 mb-3"><i className="ri-eye-line text-teal-600"></i></div>
                <h4 className="font-bold text-gray-900 mb-2">Our Vision</h4>
                <p className="text-gray-500 text-sm leading-relaxed">{a.vision}</p>
              </div>
              <div className="bg-white rounded-xl p-5 border border-gray-100">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-teal-50 mb-3"><i className="ri-focus-3-line text-teal-600"></i></div>
                <h4 className="font-bold text-gray-900 mb-2">Our Mission</h4>
                <p className="text-gray-500 text-sm leading-relaxed">{a.mission}</p>
              </div>
            </div>
            <button onClick={() => { const el = document.querySelector('#contact'); if (el) el.scrollIntoView({ behavior: 'smooth' }); }} className="inline-flex items-center gap-2 bg-teal-600 hover:bg-teal-700 text-white font-semibold px-7 py-3.5 rounded-full transition-colors cursor-pointer whitespace-nowrap">
              Work With Us <i className="ri-arrow-right-line"></i>
            </button>
          </div>
          <div className="relative">
            <div className="rounded-2xl overflow-hidden">
              <img src={a.image} alt="GeoEng Systems Team" className="w-full h-[500px] object-cover object-top" />
            </div>
            <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl p-6 border border-gray-100 w-64">
              <div className="grid grid-cols-2 gap-4">
                {[{ value: '2014', label: 'Founded' }, { value: '100+', label: 'Yrs Expertise' }, { value: '15+', label: 'Countries' }, { value: '50+', label: 'Projects' }].map((s) => (
                  <div key={s.label} className="text-center">
                    <div className="text-2xl font-bold text-teal-600">{s.value}</div>
                    <div className="text-gray-500 text-xs mt-0.5">{s.label}</div>
                  </div>
                ))}
              </div>
            </div>
            <div className="absolute -top-4 -right-4 bg-teal-600 text-white rounded-2xl p-4 text-center">
              <div className="text-2xl font-bold">10+</div>
              <div className="text-teal-200 text-xs">Years of<br />Excellence</div>
            </div>
          </div>
        </div>
        <div className="mt-28 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {strengths.map((s, i) => {
            const isActive = activeCard === i;
            return (
              <div key={s.title} onClick={() => setActiveCard(isActive ? null : i)}
                className={`relative overflow-hidden rounded-2xl p-7 cursor-pointer transition-all duration-500 ease-in-out group ${isActive ? 'bg-teal-600 scale-[1.03]' : 'bg-white hover:scale-[1.02] border border-gray-100 hover:border-teal-200'}`}>
                {isActive && <div className="absolute inset-0 opacity-20"><div className="absolute -bottom-8 -right-8 w-40 h-40 rounded-full bg-white/30"></div><div className="absolute -top-4 -left-4 w-24 h-24 rounded-full bg-white/20"></div></div>}
                <div className={`relative w-12 h-12 flex items-center justify-center rounded-xl mb-5 transition-all duration-500 ${isActive ? 'bg-white/20' : 'bg-teal-50 group-hover:bg-teal-100'}`}>
                  <i className={`${s.icon} text-2xl transition-colors duration-500 ${isActive ? 'text-white' : 'text-teal-600'}`}></i>
                </div>
                <h4 className={`relative font-bold text-lg mb-2 transition-colors duration-500 ${isActive ? 'text-white' : 'text-gray-900'}`}>{s.title}</h4>
                <p className={`relative text-sm leading-relaxed transition-colors duration-500 ${isActive ? 'text-white/80' : 'text-gray-500'}`}>{s.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
